// src/redux/initialState.js
const initialState = {
	auth: {
		loading: false,
		alertLoading: false,
		adminemail: null,
		isAuthenticated: false,
		allServices: [],
		client: null,
		subClient: null,
		notifications: [],
		notification: null, 
		allEmployees: [],
		allAlerts: [],
		alerts: [],
		allEvents: [],
		memberTasks: [],
		deleteEvents: [],
		departments: [],
		editEvents: [],
		addServices: [],
		allTasks: [],
		allMails: [],
		mail: null,
		getAllReports: [],
		id: [],
		adminSetting: [],
		allClients: [],
		clientTasks: [],
		compliances: [],

	},
};

export default initialState;
